import type { ReactNode } from "react"
import { useEntryLoading } from "src/contexts/LoadingContexts"

export interface Props {
  children?: ReactNode;
}

export function UserEntriesLoadedComponent(props: Props) {
  const { loaded } = useEntryLoading()

  if (!loaded) {
    return null
  }

  return (
    <>
      {props.children}
    </>
  )
}
